// Angular imports
import { Component, OnInit, HostBinding, Input, Host } from '@angular/core';
import { PercentPipe } from '@angular/common';

// Import types
import { Column } from '../../../types'

@Component({
    selector: 'header-cell',
    templateUrl: './header-cell.component.html',
    styleUrls: ['./header-cell.component.scss'],
    providers: [PercentPipe],
    standalone: false
})
export class HeaderCellComponent implements OnInit {
	public _label: string = '';

	// Host bindings
	@HostBinding('class.hidden') public _hidden: boolean = false;
	@HostBinding('style.width') public _width: string = '0%';
	@HostBinding('title') public _title: string = '';

	// Internal properties
	private _column: Column;

	constructor(private percentPipe: PercentPipe) { }

	/* --- Getters & setters --- */

	@Input()
	public set column(value: Column) {
		// Set column
		this._column = value;

		// Update column derived properties
		this._hidden = !!this._column?.hidden;
		this._width = this.percentPipe.transform(this._column?.width, '1.0-6');
		this._title = this._column?.name;
		this._label = this._column?.label ?? this._column?.name;
	}

	public get column(): Column {
		return this._column;
	}

	/* -- Init --- */

	public ngOnInit(): void {

	}
}
